<button mat-raised-button (click)="exportZipModelCandidats()" *ngIf="modelsExist"
        aria-disabled="false" color="accent"
        matTooltip="Télécharger les modèles de fichiers types" data-cy="btn-download-models-candidat">
  Télécharger les modèles de fichiers types
</button>

